import {useHistory} from 'react-router'
import useNavigation from '@salesforce/retail-react-app/app/hooks/use-navigation'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {useCurrentCustomer} from '@salesforce/retail-react-app/app/hooks/use-current-customer'
import {HOME_HREF} from '../../../constants'
import {sendClickEvent} from '../../../utils/gtm-utils'

/**
 * Extracts the six navigation handler callbacks used by the App shell
 * (header, drawer menu, footer links).
 *
 * `authModal` and `accountModalProps` are passed in rather than created
 * internally because useAuthModal() owns its own useDisclosure state —
 * calling it twice would produce two independent open/close states.
 */
export const useNavigationHandlers = ({onDrawerClose, authModal, accountModalProps}) => {
    const navigate = useNavigation()
    const history = useHistory()
    const {locale} = useMultiSite()
    const {data: customer} = useCurrentCustomer()

    const onLogoClick = () => {
        // Force the locale segment on the home URL to match the SSR homepage
        // redirect (homepageSeoMiddleware always redirects `/` -> `/{locale}/`).
        // We push the localized path directly instead of going through
        // useNavigation, which hard-codes `/` and drops the locale.
        const localeRef = locale?.alias || locale?.id
        history.push(localeRef ? `/${localeRef}/` : HOME_HREF)
        onDrawerClose()
    }

    const onCartClick = () => {
        navigate('/cart')
        onDrawerClose()
    }

    const onAccountClick = () => {
        accountModalProps.onOpen()
        sendClickEvent('prompt_sign_in_clicked')
    }

    const onWishlistClick = () => {
        if (customer?.isRegistered) {
            navigate('/account/wishlist')
            return
        }

        sendClickEvent('wishlist_cta_clicked')
        authModal.setIsWishlistClick(true)
        authModal.onOpen()

        navigate('/account/wishlist', 'push', {
            state: {from: {pathname: '/account/wishlist'}}
        })
    }

    const onLoyaltyClick = () => {
        navigate(customer?.isRegistered ? '/my-rewards' : '/account')
    }

    const onGiftCardClick = () => {
        navigate('/p/e-gift-card/GARGIFTCARDGBEGC001.html')
    }

    return {
        onLogoClick,
        onCartClick,
        onAccountClick,
        onWishlistClick,
        onLoyaltyClick,
        onGiftCardClick
    }
}
